import { FC } from 'react';
import styles from './styles.module.scss';
import TransactionItem from './order_item';
import Typography from '@components/common/typography';
import { TOrder, TTransactionLite } from '@xeppt/xeppt-sdk/types';
import Skeleton from '@components/common/skeleton';
import illustration from '@svg/illustrations/empty_transaction.svg';
import illustrationRequests from '@svg/illustrations/empty_requests.svg';
import { TPaymentIntent } from '@xeppt/xeppt-sdk/types/payment-intent';
import OrderItem from './order_item';

interface IProps {
    orders?: TOrder[];
    isOrdersLoading?: boolean;
    refetchOrders?: () => void;
}

const OrdersTable: FC<IProps> = ({ orders, isOrdersLoading, refetchOrders }) => {
    return (
        <div className={styles.wrapper}>
            {orders?.length === 0 && !isOrdersLoading ? (
                <div className={styles.empty_transactions}>
                    <img src={illustration} alt="illustration" />
                    <Typography variant="body3" className={styles.title}>
                        No orders yet
                    </Typography>
                    <div className={styles.description}>All orders made will be listed here</div>
                </div>
            ) : (
                <>
                    {orders?.map((item, i) => {
                        return (
                            <OrderItem
                                key={i}
                                refetchOrders={refetchOrders}
                                order={item as TOrder}
                            />
                        );
                    })}
                    {isOrdersLoading && (
                        <>
                            <Skeleton className={styles.skeleton} />
                            <Skeleton className={styles.skeleton} />
                            <Skeleton className={styles.skeleton} />
                        </>
                    )}
                </>
            )}
        </div>
    );
};

export default OrdersTable;
